import { render, staticRenderFns } from "./Destinataires.vue?vue&type=template&id=248ca8d4"
import script from "./Destinataires.vue?vue&type=script&lang=js"
export * from "./Destinataires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports